import Wallpaper from './wallpaper/Wallpaper';
import { isNotDefined, namespace } from '../utils/util';

(function ($, global) {
  "use strict";

  namespace('nc.lineage');

  nc.lineage.wallpaper = function (options) {
    if (isNotDefined(options)) throw new Error('nc.lineage.wallpaper require options object');

    const option = $.extend({
      wrap: null,
      apiDomain: '',
      global: global
    }, options);

    let wallpaper = new Wallpaper(option).init();
  };
}(jQuery, window));


// WEBPACK FOOTER //
// ./_src/js/download/wallpaper.js